var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReCampaignEvent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0H16C17.1046 0 18 0.895431 18 2V17.1543C18 18.5396 16.6259 19.5053 15.3226 19.0361L13.7608 18.4739C13.2728 18.2982 12.7356 18.319 12.2626 18.5318L9.82073 19.6307C9.29878 19.8655 8.70122 19.8655 8.17927 19.6307L5.73737 18.5318C5.26439 18.319 4.72721 18.2982 4.2392 18.4739L2.67744 19.0361C1.37412 19.5053 0 18.5396 0 17.1543V2C0 0.895431 0.895431 0 2 0ZM5 4.25C4.58579 4.25 4.25 4.58579 4.25 5C4.25 5.41421 4.58579 5.75 5 5.75H9C9.41421 5.75 9.75 5.41421 9.75 5C9.75 4.58579 9.41421 4.25 9 4.25H5ZM5 8.25C4.58579 8.25 4.25 8.58579 4.25 9C4.25 9.41421 4.58579 9.75 5 9.75H13C13.4142 9.75 13.75 9.41421 13.75 9C13.75 8.58579 13.4142 8.25 13 8.25H5ZM5 12.25C4.58579 12.25 4.25 12.5858 4.25 13C4.25 13.4142 4.58579 13.75 5 13.75H13C13.4142 13.75 13.75 13.4142 13.75 13C13.75 12.5858 13.4142 12.25 13 12.25H5Z",
    fill: "#6B7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReCampaignEvent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RE_Campaign_Event.0538dad777d6b3926970eeca3efe28c9.svg";